import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "madrid-quiz" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "madrid-quiz__content" }
const _hoisted_4 = {
  key: 0,
  class: "not-found"
}
const _hoisted_5 = { class: "madrid-quiz__footer" }
const _hoisted_6 = {
  key: 1,
  class: "madrid-quiz__footer--correct"
}
const _hoisted_7 = {
  key: 2,
  class: "madrid-quiz--final"
}
const _hoisted_8 = { class: "madrid-quiz__content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "madrid-quiz__footer" }
const _hoisted_12 = {
  key: 1,
  class: "madrid-quiz__footer--correct"
}
const _hoisted_13 = {
  key: 3,
  class: "madrid-quiz--end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type == _ctx.QuizType.INIT)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "madrid-quiz__back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
        }))
      : _createCommentVNode("", true),
    (_ctx.type == _ctx.QuizType.INIT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[28] || (_cache[28] = _createElementVNode("h1", null, "¡Prepárate para explorar Madrid!", -1)),
          _cache[29] || (_cache[29] = _createElementVNode("p", null, "Responde este pequeño formulario y estaremos listos para comenzar.", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass({
                        'madrid-quiz__field--selected': _ctx.v$.age.$model != null,
                        'madrid-quiz__field--opened': _ctx.v$.age.$dirty && _ctx.v$.age.$model == null
                    })
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("label", null, "EDAD", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.v$.age.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.age.$model) = $event)),
                placeholder: "Selecciona una franja de edad",
                options: _ctx.ageOptions,
                searchable: false,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.age.$touch()))
              }, null, 8, ["modelValue", "options"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({
                        'madrid-quiz__field--selected': _ctx.v$.groupType.$model != null,
                        'madrid-quiz__field--opened': _ctx.v$.groupType.$dirty && _ctx.v$.groupType.$model == null
                    })
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("label", null, "TIPO DE GRUPO", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.v$.groupType.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.groupType.$model) = $event)),
                placeholder: "Selecciona el tipo de grupo",
                options: _ctx.groupOptions,
                searchable: false,
                "onOption:selected": _ctx.groupTypeChange,
                onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.groupType.$touch()))
              }, null, 8, ["modelValue", "options", "onOption:selected"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["madrid-quiz__field--input", {
                        'madrid-quiz__field--selected': _ctx.v$.groupNumber.$model != null && _ctx.v$.groupNumber.$model != '',
                        'madrid-quiz__field--opened': _ctx.v$.groupNumber.$dirty 
                        && (_ctx.v$.groupNumber.$model == null || _ctx.v$.groupNumber.$model == '')
                    }])
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("label", null, "NÚMERO DE PERSONAS DEL GRUPO", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.groupNumber.$model) = $event)),
                type: "number",
                inputmode: "numeric",
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.groupNumber.$touch())),
                placeholder: "Añade aquí el número de personas"
              }, null, 544), [
                [_vModelText, _ctx.v$.groupNumber.$model]
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({
                        'madrid-quiz__field--selected': _ctx.v$.gender.$model != null,
                        'madrid-quiz__field--opened': _ctx.v$.gender.$dirty && _ctx.v$.gender.$model == null
                    })
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("label", null, "SEXO", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.v$.gender.$model,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.gender.$model) = $event)),
                placeholder: "Selecciona una opción",
                options: _ctx.genderOptions,
                searchable: false,
                onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.gender.$touch()))
              }, null, 8, ["modelValue", "options"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({
                        'madrid-quiz__field--selected': _ctx.v$.nationality.$model != null,
                        'madrid-quiz__field--opened': _ctx.v$.nationality.$dirty && _ctx.v$.nationality.$model == null
                    })
            }, [
              _cache[23] || (_cache[23] = _createElementVNode("label", null, "NACIONALIDAD", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.v$.nationality.$model,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.nationality.$model) = $event)),
                placeholder: "Selecciona una opción",
                options: _ctx.sortedCountries,
                searchable: true,
                "onOption:selected": _ctx.nationalitiyChange,
                onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.nationality.$touch()))
              }, {
                "no-options": _withCtx(({ search, searching }) => [
                  searching
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _cache[21] || (_cache[21] = _createTextVNode("Sin resultados para ")),
                        _createElementVNode("em", null, _toDisplayString(search), 1),
                        _cache[22] || (_cache[22] = _createTextVNode("."))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onOption:selected"])
            ], 2),
            (_ctx.isSpanish)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["madrid-quiz__field--input", {
                        'madrid-quiz__field--selected': _ctx.v$.postalCode.$model != null && _ctx.v$.postalCode.$model != ''
                         && !_ctx.v$.postalCode.$error,
                        'madrid-quiz__field--opened': (_ctx.v$.postalCode.$dirty 
                        && (_ctx.v$.postalCode.$model == null || _ctx.v$.postalCode.$model == '')) || _ctx.v$.postalCode.$error
                    }])
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", null, "CÓDIGO POSTAL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.postalCode.$model) = $event)),
                    type: "number",
                    inputmode: "numeric",
                    placeholder: "Ej: 24286",
                    onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.postalCode.$touch()))
                  }, null, 544), [
                    [_vModelText, _ctx.v$.postalCode.$model]
                  ])
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["madrid-quiz__go", {'ox-disabled': _ctx.isInvalid}]),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveQuiz()))
            }, _cache[25] || (_cache[25] = [
              _createElementVNode("span", null, "COMENZAR RUTA", -1),
              _createElementVNode("span", null, null, -1)
            ]), 2)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isInvalid)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass({'madrid-quiz__footer--dirty': _ctx.v$.$anyDirty && _ctx.v$.$errors.length > 0})
                }, " Por favor, completa todos los campos del formulario para poder comenzar.", 2))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, " ¡Todo listo! Ya puedes acceder a la ruta pulsando el botón ”Comenzar ruta”.")),
            _cache[26] || (_cache[26] = _createElementVNode("p", null, "La información que nos proporcionas será tratada de forma confidencial y utilizada únicamente para fines internos o estadísticos.", -1)),
            _cache[27] || (_cache[27] = _createElementVNode("div", null, null, -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.type == _ctx.QuizType.FINAL && !_ctx.showFinal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[33] || (_cache[33] = _createElementVNode("div", null, null, -1)),
          _cache[34] || (_cache[34] = _createElementVNode("h1", null, "¿Nos ayudas a seguir mejorando?", -1)),
          _cache[35] || (_cache[35] = _createElementVNode("p", null, "Selecciona uno de los emojis para puntuar la ruta que acabas de realizar.", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'any-selected': _ctx.v$.points.$model != null })
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  onClick: ($event: any) => (_ctx.selectPoints(n)),
                  class: _normalizeClass({ 'points-selected': _ctx.v$.points.$model == n })
                }, _toDisplayString(_ctx.getEmoji(n)), 11, _hoisted_9)
              }), 64))
            ], 2),
            _cache[31] || (_cache[31] = _createElementVNode("p", null, "Y por último… selecciona la parada que más te haya gustado:", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (l) => {
              return (_openBlock(), _createElementBlock("div", {
                key: l,
                class: _normalizeClass({ 'item-selected': _ctx.v$.item.$model == l})
              }, [
                _createElementVNode("span", null, _toDisplayString(l), 1),
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.selectItem(l))
                }, null, 8, _hoisted_10)
              ], 2))
            }), 128)),
            _createElementVNode("div", {
              class: _normalizeClass(["madrid-quiz__go", {'ox-disabled': _ctx.isInvalid}]),
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveQuiz()))
            }, _cache[30] || (_cache[30] = [
              _createElementVNode("span", null, "ENVIAR VALORACIÓN", -1),
              _createElementVNode("span", null, null, -1)
            ]), 2)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.isInvalid)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass({'madrid-quiz__footer--dirty': _ctx.v$.$anyDirty && _ctx.v$.$errors.length > 0})
                }, " Por favor, completa todos los campos del formulario para poder comenzar.", 2))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, " ¡Todo listo! Ya puedes enviar tu valoración sobre esta ruta y finalizar.")),
            _cache[32] || (_cache[32] = _createElementVNode("div", null, null, -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showFinal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _cache[36] || (_cache[36] = _createElementVNode("div", null, null, -1)),
          _cache[37] || (_cache[37] = _createElementVNode("h1", null, "¡Gracias por tu valoración!", -1)),
          _cache[38] || (_cache[38] = _createElementVNode("p", null, "La ruta que estabas realizando ya ha finalizado. ¿Qué quieres hacer ahora?", -1)),
          _createElementVNode("div", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.close(false)))
          }, "SEGUIR EN LA RUTA ACTUAL"),
          _createElementVNode("div", {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.close(true)))
          }, "IR AL LISTADO DE RUTAS")
        ]))
      : _createCommentVNode("", true)
  ]))
}